(function ($) {
  threeStepPromoLpItemV1 = {
    formatter: $('.three-step-promo-lp-item-v1')
  };

  Drupal.behaviors.threeStepPromoLpItemV1 = {
    get: function (key) {
      return threeStepPromoLpItemV1[key];
    },

    set: function (key, val) {
      threeStepPromoLpItemV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

      // thisFormatter.find('.add-to-bag').addClass('pc');
      });
    },

    bindAddToBag: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      // Set ADD ALL TO BAG button
      $('.add-to-bag', context).on('click', function(e) {
        e.preventDefault();
        var buySkus = [];
        var container = $($(e.target).parents('.row').get(0));
        var $form = container.find('form');
        var $offerCodeEl = container.find('[name="GROUP_NAME"]');
        var offerCode = $offerCodeEl ? $offerCodeEl.val() : 'promo_pick_3step';
        var manualIds = container.attr('data-allskuids');

        if (manualIds) {
        // if the container has a list of manually added, preferred skuids, use those
          var skuIds = manualIds.split(/ *, */);

          buySkus = $.map(skuIds, function (el) {
            return el.replace(/SKU/, '');
          });
        } else {
        // else iterate through each product div to get sku for 'add all to cart'
          container.find('div[data-productid]').each(function () {
            buySkus.push(Drupal.behaviors.ctaButton.actions.getSkuId($(this)));
          });
        }
        if ($form) {
        // do this as a form submit
          var $formSkus = $form.find('[name="' + offerCode + '"]');

          if (!$formSkus.length) {
            $.each(buySkus, function (i, skuId) {
              $form.append('<input type="hidden" name="' + offerCode + '" value="' + skuId + '">');
            });
            var $successUrl = $('.success-url');
            var isCheckout = $.inArray('is_checkout', Drupal.cl.getQSParams()) > -1 ? 1 : 0;

            if ($successUrl.length && !isCheckout) {
              $form.append('<input type="hidden" name="SUCCESS_URL" value="' + $successUrl.html() + '">');
            }
          }
          $form.trigger('submit');
        } else {
        // do this via RPC
          var loadingId = site.loading.show({
            'target': e.target,
            'matchTarget': ['display', 'height', 'width'],
            'css': {
              'text-align': 'center',
              'vertical-align': 'bottom',
              'margin-bottom': '0'
            }
          });

          // add sku array to cart
          site.addToCart({
            skuBaseId: buySkus
          });
        }
        $(document).one('addToCart.success addToCart.failure', function () {
          site.loading.hide(loadingId);
        });
      });
    }

  };
})(jQuery);
